/*
 *
 * Date: 2025
 * Description: Main components for part display
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box , Typography , Grid, IconButton, Button, Paper} from "@mui/material";
import { ReactElement } from "react";

//Interfaces
import { i_part_card_complete_props } from "../../interfaces/display.interfaces";

//Icons
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

//Hooks
import { useViewModal } from "../../context/view.modal.context";
import { useFitModal } from "../../context/fit.modal.context";


const UserPartCard = ( props : i_part_card_complete_props ) : ReactElement => {
    const C = props.part
    const { showPartModal } = useViewModal()
    const { showFitModal } = useFitModal()
    return(
        <Box sx={{ width : '100%' ,}}>
            <Paper elevation={4} sx={{ border : props.in? '2px solid lime': '1px solid #EAECF0' , padding : 1 }}>
                    <Grid container>
                        <Grid size={{ xl : 2 , lg : 2, md : 2.5, xs : 12}}>
                            <Box sx={{ width: 220, height: 170,display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }} onClick={() => showPartModal(C.path)} >
                                <Box component="img" sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} src={props.path + C.path} />
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 6, lg : 5.0 , md : 4.5, xs : 12}} p={1}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 140}}>
                                <Typography sx={{ textDecoration : 'underline' , fontWeight : 800}}>Parts link : {C.sku}</Typography>
                                <Typography sx={{ fontSize :14}}>{C.description}</Typography>
                                <Typography sx={{ fontWeight : '700'}}>{C.categories !== null ? C.categories : "No category found"}</Typography>
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 2 ,md : 4.0, xs : 12}}>
                            <Box sx={{ display : 'flex' , flexDirection : 'column' , justifyContent: 'space-between', height: 140}}>
                                <Box sx={{ display : 'flex'}}> Price : <Typography sx={{ marginLeft :' 4px' , fontWeight : C.price !== null ? '800' : 'initial'}}>{ C.price === null? 'Not available' : C.price  + '$'  }</Typography></Box>
                                <Box sx={{ display : 'flex'}}>Stock : <Typography sx={{ marginLeft :' 4px' }}>{C.stock === null? 'Not available' : C.stock  }</Typography></Box>
                                <Button variant="contained" onClick={() => showFitModal(C.car_fit)}>Part compatiblity </Button>
                            </Box>
                        </Grid>
                       
                        <Grid size={{ xl: 1.5 , lg : 1.0, md : 1.0, xs : 12 }} sx={{ alignContent : 'center'}}>
                            {!props.in && 
                                <Box sx={{ display : 'flex' , justifyContent : 'center' }}>                            
                                    {props.type === 'catalog' &&
                                        <IconButton sx={{ cursor : 'pointer'}} disabled={props.in} onClick={() => props.addPart(C)}>
                                            <AddShoppingCartIcon sx={{ fontSize : 30}} color={'primary'} />
                                        </IconButton>
                                    }
                                </Box>
                            }
                        </Grid>
                    </Grid>
            </Paper>
            
        </Box>
    )
}

export default UserPartCard